import { render, staticRenderFns } from "./scales.vue?vue&type=template&id=52f61c4f"
import script from "./scales.vue?vue&type=script&lang=js"
export * from "./scales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports